<template>
  <div :data-clazz="model.clazz">
    <div class="panelTitle">{{ i18n['startEvent'] }}</div>
    <div class="panelBody">
      <DefaultDetail :model="model" :on-change="onChange" :read-only="readOnly" />
      <div class="panelRow">
        <div>之后任务：</div>
        <a-select
          :disabled="readOnly"
          :filterOption="true"
          :value="model.task"
          @change="(e) => onChange('task', e)"
          mode="multiple"
          placeholder="选择任务"
          style="width:90%; font-size:12px"
        >
          <a-select-option
            :key="taskIndex"
            :title="taskValue.name"
            :value="taskValue.full_name"
            v-for="(taskValue, taskIndex) in tasks"
          />
        </a-select>
      </div>
      <NodeDetail
        :model="model"
        :on-change="onChange"
        :read-only="readOnly"
        :templates="templates"
        :templates-base="templatesBase"
        :users="users"
        :write-preview="false"
      />
    </div>
  </div>
</template>
<script>
  import DefaultDetail from './DefaultDetail'
  import NodeDetail from './NodeDetail'
  export default {
    inject: ['i18n'],
    name: 'StartEventDetail',
    components: {
      DefaultDetail,
      NodeDetail
    },
    props: {
      model: {
        type: Object,
        default: () => ({})
      },
      tasks: {
        type: Array,
        default: () => ([])
      },
      onChange: {
        type: Function,
        default: () => { }
      },
      readOnly: {
        type: Boolean,
        default: false
      },
      templates: {
        type: Array,
        default: () => ([])
      },
      templatesBase: {
        type: Array,
        default: () => ([])
      },
      users: {
        type: Array,
        default: () => ([])
      }
    }
  }
</script>
